 

$(document).on("click",".pplr_tab_index",function(){
   let tab_id = $(this).data('tab');
  $("#pplr_tab_"+tab_id).find(".pplr-swatch-element").eq(0).trigger("click");

  
});
  
$(document).on("change",".fileupload",function(){
  $(".pplr_text").val("");
  // for note and button disable
  setTimeout(ShowATtocart, 100);
   
});
  $(document).on("click",".pplr_delete",function(){
    $(".pplr_text").val("");
    
});
 $(document).on("click",".pplrimage",function(){
    $(".pplr_text").val("");
   $(".pplr_delete").trigger("click");
   
}); 
  
  $(document).on("click",".pplr-c-button,.pplr_deselect",function(){
    setTimeout(function(){
    if($(".pplr_tab").hasClass("pplr_active")){
      
      $(".pplr_tab").removeClass("pplr_active");
      $(".pplr_text").val("");
    }
    },1000);
  });
  
  
    $(document).one("click",".pplr-c-button",function(){
    setTimeout(function(){
    if(!$(".pplrfileuploadbutton").find(".pplrfileuploadbutton").hasClass("guidelines")){
      $(".pplrfileuploadbutton").prepend('<div class="guidelines"><div class="tile"><div><i class="an an-image"></i></div><span>Image must be 300px (W or H)</span></div><div class="tile"><div><i class="an an-ban"></i></div><span>No photographs</span></div><div class="tile"><div><i class="an an-copyright"></i></div><span>No copyright infringement</span></div><div class="tile"><div><i class="an an-lamp"></i></div><span>No trademark infringement</span></div></div>');
    }
    },1000);
  });

let tab_id = "";
$(document).on("click",".pplr_tab_index",function(){
    tab_id = $(this).data('tab');
   $(".pplr_tab_index").hide();
   $(this).show();
 
   $('.pplr_deselect').attr('style', 'display:none !important');

   $('.gobackbutton').remove();

   $('#pplr_tab_'+ tab_id).prepend('<span class="gobackbutton"><i class="an an-angle-left"></i>Clear</span>');
     

   
   setTimeout(activeBottomPart, 500);

   setTimeout(colorChange, 500); 

    // for note and button disable
    if(tab_id == 1){
      setTimeout(hideATtocart, 100);
    } else if( tab_id == 1){
      setTimeout(hideATtocart, 100);
    } else if(tab_id == 1){
      setTimeout(hideATtocart, 100);
    } else {
      setTimeout(ShowATtocart, 100); 
    }


$(".carcontednote").hide();
   // end here          
});

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));


$(document).on("click",".gobackbutton",function(){
  
  
  const $pplr_tab = $(this).closest('.pplr_tab');
  const $textInput = $pplr_tab.find(".pplr_text");
  $textInput.val("").trigger("input");
  
  setTimeout(function(){
    $(".pplr_tab_index").show();  
  
    
     $(".pplr_tab_index").removeClass("pplr_active"); 
     $('#pplr_tab_'+ tab_id).removeClass("pplr_active"); 
     
     $('.pplr_deselect').click();
     delay(500);
     $(".pplr_tab_index").removeClass("pplr_active"); 
  
      // for note and button disable
      setTimeout(hideATtocart, 100); 
  
      $(".notecustomize").show();
    
  }, 400)
  
  
});


$(document).on("click",".ptc_button, .pplr-c-button",function(){
   setTimeout(function(){
      $(".pplr_tab_index").removeClass("pplr_active"); 
     
      // for note and button disable
      $(".notecustomize").remove();
     
       $('.pplr_ex_inner').before('<p class="notecustomize carcontednote">You have not chosen any product customizations, please adjust to add to cart</span>');

     
     setTimeout(hideATtocart, 500); 

     // end here
     
   },500);   
});
  


function getallspanlist(){  

   var clorselectedNow = $('.swatch--active').attr('data-swatch').toLowerCase();
  
  if( clorselectedNow == 'black'){
        clorselectedNow = "silver";
     } else {
        clorselectedNow = "black";
     }

   $(".pplr_tab_wrapper .pplr_tab_index").each(function() { 
          var datavalue = $(this).attr('data-tab'); 
     
           if( clorselectedNow == 'silver' & datavalue == '10' ){
            // $(this).hide();
           } else if( clorselectedNow == 'black' & datavalue == '7' ) {
             // $(this).hide();
           } else {
             $(this).show();
           }
    });
  
   $(".pplr_tab_index").removeClass("pplr_active"); 
   $('#pplr_tab_'+ tab_id).removeClass("pplr_active"); 
   $('.pplr_deselect').click();
    
}
  
function colorChange(){
     var clorselectedNow = $('.swatch--active').attr('data-swatch').toLowerCase();
     console.log(clorselectedNow);
  if( clorselectedNow == 'stainless steel'){
    
        $('.pplr_monogram').attr('data-color', '#000000'); 
        $('.pplrjscolor').attr('data-color', '#8e8e8e');
    
     } else {
        $('.pplr_monogram').attr('data-color', '#8e8e8e');
        $('.pplrjscolor').attr('data-color', '#8e8e8e');
       
     } 
  }


 function activeBottomPart(){
   if($('#pplr_tab_'+ tab_id).hasClass("pplr_active")){
       
   } else { 
     $('#pplr_tab_'+ tab_id).addClass("pplr_active");
   }
 }

   // for note and button disable
$(document).on("click",".pplr_delete",function(){
   setTimeout(function(){

      var dfmn = jQuery(".jscroll li.pplr_img_w");
      if( dfmn.length > 0 ){
        
      } else {
         setTimeout(hideATtocart, 100); 
      }
       
   },100);   
});


$(document).on("keyup",".pplr-text .pplr_text",function(){
   if(tab_id == 1){
   if(this.value.length > 0 ){
      setTimeout(ShowATtocart, 100);
   } else {
     setTimeout(hideATtocart, 100); 
   }
   } else {
     setTimeout(ShowATtocart, 100);
   }  
      
});

// end here   

  function hideATtocart(){
    $(".carcontednote").show();
       jQuery('.pplr_ex_button button[name="add"]').prop("disabled", true); 
          
    
  }


  function ShowATtocart(){  
    
    $(".carcontednote").hide();
    jQuery('.pplr_ex_button button[name="add"]').prop("disabled", false);    
  }

$(document).on("click", ".product-personalizer-cal-now", function() {
 
  var $this = $(this);

  var productID = $this.attr('data-handle');
  
  window.location.href = window.Shopify.routes.root + 'products/'+ productID;
  
/*
  
  $.getJSON(window.Shopify.routes.root + 'products/' + productID + '.js', function(product) {
    pplr_product = product;
    cstmfy_personalize_text($this, event);
  });*/
});



function getALLButtonPeronnalizer(){
  
  var numItems = $('.index-section--featured-product').length;

  if( numItems > 0 ){
  $( ".product-personalizer" ).each(function(index) {
    console.log(this);
      $(this).hide();
     var productIDnumber = $( this ).attr('data-id');
     var productDataHandle = $( this ).attr('data-handle');
     var htmlbutton = '<div id="pplr-'+ productIDnumber +'" data-id="'+ productIDnumber +'" class="product-personalizer-cal-now" data-handle="'+ productDataHandle +'"><button type="button" class="btn pplr-c-button pplr-btn button Button--secondary ptc_button">Personalize It</button></div>';

     var productDisplayID = '#product_form_' + productIDnumber + ' .product-form__controls-group--submit';

     $(productDisplayID).prepend(htmlbutton);
    
  });

  }
  
} 

setTimeout(getALLButtonPeronnalizer, 3000);
$(document).on("keyup",".pplr-text .pplr_text",function(){
  const numbers = /^[A-Za-z0-9\s]*$/;
  var getValue = $(this).val(); 
      if(getValue.match(numbers)){ 
        console.log("value accepted");
       } else {
	       $(this).val('');
        console.log("value not accepted");
	   }
      
});